import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AltaPay from '@/shared/checkout/altapay/ui/AltaPay.vue';
import { AltaPayPaymentPlaceHolderTileModel } from '@/types/B2CcontentServerContract';

export default /*#__PURE__*/_defineComponent({
  __name: 'AltaPayPaymentPlaceHolderTileModel',
  props: {
    content: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AltaPay, {
    "shop-name": __props.content.shopName,
    "form-styling-url": __props.content.formStylingUrl,
    "gateway-base-url": __props.content.gatewayBaseUrl
  }, null, 8, ["shop-name", "form-styling-url", "gateway-base-url"]))
}
}

})